import * as React from 'react';
import H1Header from "./H1Header";
import H1Text from "./H1Text";
import H2Header from "./H2Header";
import H2Text from "./H2Text";
import { useLocation } from "react-router-dom";
var KitHomeHeader = function () {
  var location = useLocation();
  if (!location.pathname.match(/^\/(seite\/\d+\/|welcome|kategorie\/.+\/)?$/)) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "prodwidth l-container h-center"
  }, /*#__PURE__*/React.createElement(H1Header, {
    text: window.layoutSettings.seo.home.h1.title
  }), /*#__PURE__*/React.createElement(H1Text, {
    text: window.layoutSettings.seo.home.h1.text
  }), /*#__PURE__*/React.createElement(H2Header, {
    text: window.layoutSettings.seo.home.h2.title
  }), /*#__PURE__*/React.createElement(H2Text, {
    text: window.layoutSettings.seo.home.h2.text
  }));
};
export default KitHomeHeader;